import React from "react";
import { Link, TextField, Button, Modal, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { Box } from "@mui/system";
import "../Claimassistant/Claimassistant.scss";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SlidingPanel from "react-sliding-side-panel";
interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}

const Community: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [addpostQuestions, setPostQuestions] = React.useState(false);
  const [postNewQuestions, setPostNewQuestions] = React.useState("");
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  var questions_data_origional = [
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Umesh Gemini",
      question:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      date: "22, August, 2022",
      upvotes: "2",
      answer_open_status: "false",
      answers: [
        {
          logo: "/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
          username: "Rahul Kumar",
          date: "02, August, 2022",
          answer: "No, Baleno is better for city.",
          upvotes: "10000",
        },
        {
          logo: "/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
          username: "Rahul Kumar",
          date: "02, August, 2022",
          answer: "No, Baleno is better for city.",
          upvotes: "10000",
        },
        {
          logo: "/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
          username: "Rahul Kumar",
          date: "02, August, 2022",
          answer: "No, Baleno is better for city.",
          upvotes: "10000",
        },
      ],
    },
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Umesh Gemini",
      question:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      date: "22, August, 2022",
      upvotes: "2",
      answer_open_status: "false",
      answers: [
        {
          logo: "/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
          username: "Rahul Kumar",
          date: "02, August, 2022",
          answer: "No, Baleno is better for city.",
          upvotes: "10000",
        },
      ],
    },
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Umesh Gemini",
      question:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      date: "22, August, 2022",
      upvotes: "2",
      answer_open_status: "false",
      answers: [
        {
          logo: "/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
          username: "Rahul Kumar",
          date: "02, August, 2022",
          answer: "No, Baleno is better for city.",
          upvotes: "10000",
        },
      ],
    },
  ];
  const [questions, setQuestions] = React.useState(questions_data_origional);
  const [productTabsStatus, setProductTabsStatus] = React.useState("Q&A");
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const answer_open_status_changes = (index: number) => {
    var questions_data = questions;

    questions_data[index].answer_open_status =
      questions_data[index].answer_open_status == "true" ? "false" : "true";

    setQuestions(questions_data);
  };
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  return (
    <Grid container spacing={3} className="trendingQuestions">
      <Grid xs={6}>
        <h3 className="mb-0">Community</h3>
      </Grid>
      {productTabsStatus == "Q&A" ? (
        <Grid xs={6} className="text-right">
          <Link
            className="greenBtn addfile"
            underline="none"
            onClick={() => {
              setPostQuestions(true);
            }}
          >
            Post a question
          </Link>
          {/* <Modal open={addpostQuestions} className="modalWrapper">
            <Box className="modalInner">
              <Grid container spacing={2}>
                <Grid xs={12}>
                  <Link
                    
                    className="close-button"
                    onClick={() => {
                      setPostQuestions(false);
                    }}
                  />
                  <h5 className="popup-heading">What’s on your mind</h5>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                className="mb-4"
              >
                <Grid xs={12}>
                  <RKTextField
                    class_name="inputField"
                    title="Write your question here"
                    value={postNewQuestions}
                    value_update={updateMasterState}
                    attrName={setPostNewQuestions}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button variant="contained" className="submitBtn">
                    Post Query
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal> */}
          <SlidingPanel
            type={"right"}
            isOpen={addpostQuestions}
            size={75}
            panelClassName="slidingPanel"
            backdropClicked={() => setPostQuestions(false)}
          >
            <Box
              className={open_status == true ? "modalInner show" : "modalInner"}
            >
              {pageStatus == 5 ? null : (
                <Grid container spacing={3} alignItems="center">
                  <Grid xs={6}>
                    <h4 className="mb-0 mt-3 text-left">What’s on your mind</h4>
                  </Grid>
                </Grid>
              )}
              {pageStatus == 2 ? null : (
                <div className="scrollable_area">
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <Typography>
                        <Grid
                          container
                          spacing={2}
                          justifyContent="center"
                          sx={{ padding: "0px" }}
                        >
                          <Grid xs={12}>
                            <RKTextField
                              class_name="inputField"
                              title="Write your question here"
                              value={postNewQuestions}
                              value_update={updateMasterState}
                              attrName={setPostNewQuestions}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
              )}

              {pageStatus == 2 ? (
                <Grid container spacing={2}>
                  <Grid xs={12} className="tick_animation">
                    <svg
                      className="checkmark"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 52 52"
                    >
                      <circle
                        className="checkmark__circle"
                        cx="26"
                        cy="26"
                        r="25"
                        fill="none"
                      />
                      <path
                        className="checkmark__check"
                        fill="none"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                      />
                    </svg>
                    <p className="quote_success">
                      New Question has been added successfully!
                    </p>
                  </Grid>
                </Grid>
              ) : null}
              <Grid container spacing={2}>
                {pageStatus == 2 ? null : (
                  <Grid
                    xs={12}
                    style={{ textAlign: "center", position: "relative" }}
                    className="ctaBtn"
                  >
                    <Button
                      variant="contained"
                      className="submitBtn fixedbtn"
                      onClick={() => {
                        changePageStatus(true);
                      }}
                    >
                      {pageStatus == 1 ? "Post Query" : "Continue"}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          </SlidingPanel>
        </Grid>
      ) : null}

      <Grid xs={12}>
        <div className="productTabs">
          <Button
            className={
              productTabsStatus == "Q&A" ? "defaultTab active" : "defaultTab"
            }
            onClick={() => {
              setProductTabsStatus("Q&A");
            }}
          >
            Q & A
          </Button>
          <Button
            className={
              productTabsStatus == "articles"
                ? "defaultTab active"
                : "defaultTab"
            }
            onClick={() => {
              setProductTabsStatus("articles");
            }}
          >
            Articles
          </Button>
          <Button
            className={
              productTabsStatus == "tips" ? "defaultTab active" : "defaultTab"
            }
            onClick={() => {
              setProductTabsStatus("tips");
            }}
          >
            Tips
          </Button>
          {/* <Button
            className={
              productTabsStatus == "term" ? "defaultTab active" : "defaultTab"
            }
            onClick={() => {
              setProductTabsStatus("term");
            }}>
            Tips
          </Button> */}
          <Button
            className={
              productTabsStatus == "trueStories"
                ? "defaultTab active"
                : "defaultTab"
            }
            onClick={() => {
              setProductTabsStatus("trueStories");
            }}
          >
            True Stories
          </Button>
        </div>
      </Grid>
      <Grid xs={12}>
        {questions.map((data, index) => {
          return (
            <Box className="questionPost">
              <Grid container spacing={2}>
                <Grid xs={12} className="postTitle">
                  <div className="userIcon">
                    <img src={data.logo} />
                  </div>
                  <div className="userName">
                    <h6>{data.username}</h6>
                    <p>{data.date}</p>
                  </div>
                </Grid>
                <Grid xs={12}>
                  <p className="question">{data.question}</p>
                </Grid>
                <Grid xs={12} className="greySection">
                  <Grid container spacing={2}>
                    <Grid xs={12}>
                      <Link className="upvote active" underline="none">
                        {data.upvotes} upvotes
                      </Link>
                      <Link
                        className="answer"
                        underline="none"
                        onClick={() => {
                          answer_open_status_changes(index);
                        }}
                      >
                        {data.answers.length} answers
                      </Link>
                    </Grid>
                  </Grid>
                  {data.answer_open_status === "false" ? null : (
                    <Box className="postGroup">
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        placeholder="Add answer"
                      />
                      <Button>Post</Button>
                    </Box>
                  )}
                  {data.answer_open_status == "false"
                    ? null
                    : data.answers.map((dataAns, indexAns) => {
                        return (
                          <div>
                            <Grid container spacing={2} className="innerPost">
                              <Grid xs={12} className="postTitle">
                                <div className="userIcon">
                                  <img src={dataAns.logo} />
                                </div>
                                <div className="userName">
                                  <h6>{dataAns.username}</h6>
                                  <p>{dataAns.date}</p>
                                </div>
                              </Grid>
                              <Grid xs={12}>
                                <p className="question">{dataAns.answer}</p>
                              </Grid>
                              <Grid xs={12}>
                                <Link
                                  className="upvote active"
                                  underline="none"
                                >
                                  {dataAns.upvotes} upvotes
                                </Link>
                              </Grid>
                            </Grid>
                          </div>
                        );
                      })}
                </Grid>
              </Grid>
            </Box>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Community;
